// Player news on the wire. PLAYER_NEWS.md, scenario E4,
// PLAN-2026-09-26-every-screen-and-crayon P4.

import { z } from 'zod';
import { pageOf } from './envelope';
import { NewsFilter, NewsView } from './views';

/** `GET /api/leagues/:id/news` as a query string: which items, and where the last page ended. */
export const NewsQuery = z.object({
  /** Mine is the default: never a wall of everybody's news (PLAYER_NEWS.md). */
  filter: NewsFilter.default('mine'),
  cursor: z.string().min(1).optional(),
  /**
   * Only stories about players who play one of these positions (any of
   * his, the pool's rule), a comma list in the query string; empty is every
   * position. At most 32, as the pool's. Added 2026-10-18 (B-416).
   */
  positions: z.array(z.string().min(1).max(16)).max(32).default([]),
});
export type NewsQuery = z.infer<typeof NewsQuery>;

/** A page of news, newest first. */
export const NewsPage = pageOf(NewsView);
export type NewsPage = z.infer<typeof NewsPage>;
